<template>
	<a
		class="bm-view"
		href="javascript:void(0)"
		role="button"
		:title="'查看地图：' + title"
		@click.prevent="onOpen"
	>
		<img class="bm-view__img" :src="mapImg" :alt="title" />
	</a>
</template>

<script>
import { openAddressMap } from './baidu-map'

export default {
	name: 'AddressStaticMap',
	props: {
		mapImg: { type: String, required: true },
		title: { type: String, required: true },
		address: { type: String, required: true },
		lng: { type: Number, required: true },
		lat: { type: Number, required: true },
	},
	computed: {
		isMobileEnd() {
			return this.$store.state.isMobileEnd
		},
	},
	methods: {
		onOpen() {
			openAddressMap({
				lat: this.lat,
				lng: this.lng,
				title: this.title,
				address: this.address,
				isMobile: this.isMobileEnd,
			})
		},
	},
}
</script>

<style scoped>
.bm-view {
	display: block;
	width: 100%;
	height: 400px;
	overflow: hidden;
	background: #f0f0f0;
	cursor: pointer;
}
.bm-view__img {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
	border: 0;
}
@media screen and (max-width: 768px) {
	.bm-view {
		height: 197px !important;
	}
}
</style>
